var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoTextLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.51 10.875L4.51001 10.875C3.88869 10.875 3.38501 10.3713 3.38501 9.75C3.38501 9.12868 3.88869 8.625 4.51001 8.625L20.51 8.625C21.1313 8.625 21.635 9.12868 21.635 9.75C21.635 10.3713 21.1313 10.875 20.51 10.875ZM20.51 19.875L4.51001 19.875C3.88869 19.875 3.38501 19.3713 3.38501 18.75C3.38501 18.1287 3.88869 17.625 4.51001 17.625L20.51 17.625C21.1313 17.625 21.635 18.1287 21.635 18.75C21.635 19.3713 21.1313 19.875 20.51 19.875Z",
    fill: "#343C54 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.51 13.125C16.1313 13.125 16.635 13.6287 16.635 14.25C16.635 14.8713 16.1313 15.375 15.51 15.375H4.51001C3.88869 15.375 3.38501 14.8713 3.38501 14.25C3.38501 13.6287 3.88869 13.125 4.51001 13.125H15.51Z",
    fill: "#343C54 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.51 4.125C16.1313 4.125 16.635 4.62868 16.635 5.25C16.635 5.87132 16.1313 6.375 15.51 6.375H4.51001C3.88869 6.375 3.38501 5.87132 3.38501 5.25C3.38501 4.62868 3.88869 4.125 4.51001 4.125H15.51Z",
    fill: "#343C54 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoTextLeft);
export default __webpack_public_path__ + "static/media/DuoTextLeft.df401eb2fb0128520139e63c7f337d39.svg";
export { ForwardRef as ReactComponent };